// Actions
export const AUTH__GET_TOKEN_FROM_ACCESS_CODE = 'AUTH__GET_TOKEN_FROM_ACCESS_CODE';
export const AUTH__JWT_FETCH = 'AUTH__JWT_FETCH';
export const AUTH__JWT_RECEIVED = 'AUTH__JWT_RECEIVED';
export const AUTH__LOGIN = 'AUTH__LOGIN';
export const AUTH__LOGIN_SUCCESS = 'AUTH__LOGIN_SUCCESS';
export const AUTH__REQUEST_PASSWORD = 'AUTH__REQUEST_PASSWORD';
export const AUTH__RESET_PASSWORD = 'AUTH__RESET_PASSWORD';
export const AUTH__SIGN_OUT = 'AUTH__SIGN_OUT';
export const AUTH__SYNC_LOGIN = 'AUTH__SYNC_LOGIN';
export const AUTH__UPDATE_TOKEN = 'AUTH__UPDATE_TOKEN';
export const AUTH__VALIDATE_AUTHORIZED_USER = 'AUTH__VALIDATE_AUTHORIZED_USER';

// Getters
export const AUTH__IS_CUSTOMER_LEAD = 'AUTH__IS_CUSTOMER_LEAD';
export const AUTH__IS_LOGGED_IN = 'AUTH__IS_LOGGED_IN';
export const AUTH__IS_PROPERTY_MANAGER = 'AUTH__IS_PROPERTY_MANAGER';
export const AUTH__JWT = 'AUTH__JWT';
export const AUTH__PROCESSING_ORDER = 'AUTH__PROCESSING_ORDER';
export const AUTH__PROCESSING_CUSTOMER_LEADS = 'AUTH__PROCESSING_CUSTOMER_LEADS';
export const AUTH__TOKEN = 'AUTH__TOKEN';

// Mutations
export const AUTH__JWT_IS_LOADING = 'AUTH__JWT_IS_LOADING';
export const AUTH__JWT_MUTATE = 'AUTH__JWT_MUTATE';
export const AUTH__MUTATE_CUSTOMER = 'AUTH__MUTATE_CUSTOMER';
export const AUTH__MUTATE_LOADING_STATUS = 'AUTH__MUTATE_LOADING_STATUS';
export const AUTH__MUTATE_TOKEN = 'AUTH__MUTATE_TOKEN';
export const AUTH__MUTATE_USER = 'AUTH__MUTATE_USER';
export const AUTH__RESET = 'AUTH__RESET';
